import { useEffect, useState } from 'react';

/**
 * Returns true on devices that have no hover capability (phones/tablets),
 * where hover-only interactions can never be triggered.
 */
export default function useNoHover(): boolean {
  const [noHover, setNoHover] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mql = window.matchMedia('(hover: none)');
    const update = () => setNoHover(mql.matches);

    update();
    mql.addEventListener('change', update);

    return () => mql.removeEventListener('change', update);
  }, []);

  return noHover;
}